// WP-18 — derive the Indian academic year and copyright year from the clock, never hard-code
// them (the marketing hero shipped "AY 2025–26" into August 2026, and every footer said "© 2026"
// forever). The Indian AY starts in April.
export const academicYearStart = (d = new Date()) => {
  const y = d.getFullYear();
  return d.getMonth() >= 3 ? y : y - 1; // month is 0-based; April = 3
};

/** "AY 2026–27" style label (en dash, two-digit end year). */
export const academicYear = (d = new Date()) => {
  const start = academicYearStart(d);
  return `AY ${start}–${String(start + 1).slice(-2)}`;
};

/** "2026–27" — the bare span, for copy like "academic year 2026–27". */
export const academicYearSpan = (d = new Date()) => {
  const start = academicYearStart(d);
  return `${start}–${String(start + 1).slice(-2)}`;
};

export const copyrightYear = (d = new Date()) => d.getFullYear();
